<template>
  <div class="patterns-div" :style="{backgroundImage:`url(${bgimage})`}">
    <div class="patterns-div-c" style="width: 100%; height: 100%;">
      <van-row class="button-row">
        <van-col class="button-col" span="12">
          <div class="select-button" @click="gotoTypes(0)" :style="{backgroundImage:`url(${buttonBg})`}">
            <div class="button-div">
              中老年慢病康复锻炼
            </div>
          </div>
        </van-col>
        <van-col class="button-col" span="12">
          <div class="select-button" @click="gotoTypes(1)" :style="{backgroundImage:`url(${buttonBg})`}">
            <div class="button-div">
              青少年体育锻炼
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {Field, Button, Toast, Cell, CellGroup, Row, Col, Dialog} from 'vant'
export default {
name: 'ExercisePatterns',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data(){
    return {
      bgimage: require('@/assets/css/patterns_bg.png'),
      buttonBg: require('@/assets/css/button_bg.png')
    }
  },
  methods: {
    gotoTypes(type){
      this.$router.push({ path: '/exercise/types', query: {type: type}})
    }
  }
}
</script>

<style scoped>
  .button-row{
    display: flex;
    align-items: center;
    width: 100%;
    height: 45rem;
  }
  .button-col{
    text-align: center;
    display: flex;
    justify-content: center;
    height: 100%;
  }
  .select-button{
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: 100% 100%;
    border: none;
    width: 10rem;
  }
  .button-div{
    width: 4rem;
    font-size: 3rem;
    word-wrap: break-word;
    margin: 3rem;
  }
  .patterns-div{
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
    height: 100%;
    padding-bottom: 0;
    background-color: white;
  }
  .patterns-div-c{
    display: flex;
    align-items: center;
    height: 100%;
  }
</style>
